"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STANDARD_CODE_SEPARATOR = exports.STANDARD_SET_CODE_PREFIXES = void 0;
exports.STANDARD_SET_CODE_PREFIXES = {
    'CC-CCSS': [
        'CCSS.ELA-Literacy.',
        'CCSS.Math.Content.',
        'CCSS.Math.Practice.',
    ],
    'TX-TEKS': ['SCI.', 'MA.'],
    'TN-AS': ['MA.'],
    'IN-AS': ['IN.AS.MA.'],
    'UT-USBE': ['UT.CS.MA.', 'MA.'],
    'OR-AS': ['MA.'],
    'GA-SE': ['MA.'],
};
exports.STANDARD_CODE_SEPARATOR = '$';
//# sourceMappingURL=standard-set.constants.js.map